import { Button } from "antd";
import React from "react";
import { Link } from "react-router-dom";

const BackComponent = () => {
  return (
    <div>
      <Link to="/">
        <Button type="danger">Back</Button>
      </Link>
    </div>
  );
};

export default BackComponent;
